module.exports = __webpack_public_path__ + "img/bin-c-3.0b4c6884.svg";